import type { LoaderFunctionArgs } from "@remix-run/node";
import { json } from "@remix-run/node";
import {
  Links,
  Meta,
  Outlet,
  Scripts,
  ScrollRestoration,
  useRouteError,
  useLoaderData,
  isRouteErrorResponse,
} from "@remix-run/react";
import { captureRemixErrorBoundaryError, withSentry } from "@sentry/remix";

export const loader = async ({ request: _request }: LoaderFunctionArgs) => {
  return json({
    ENV: {
      SENTRY_DSN: process.env.SENTRY_DSN || "",
    },
  });
};

function App() {
  const { ENV } = useLoaderData<typeof loader>();

  return (
    <html lang="en">
      <head>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width,initial-scale=1" />
        <link rel="preconnect" href="https://cdn.shopify.com/" />
        <link rel="stylesheet" href="https://cdn.shopify.com/static/fonts/inter/v4/styles.css" />
        <Meta />
        <Links />
      </head>
      <body>
        <div id="fb-root"></div>
        <Outlet />
        <ScrollRestoration />
        <script
          dangerouslySetInnerHTML={{
            __html: `window.ENV = ${JSON.stringify(ENV)}`,
          }}
        />
        <Scripts />
      </body>
    </html>
  );
}

export const ErrorBoundary = () => {
  const error = useRouteError();
  captureRemixErrorBoundaryError(error);

  let errorMessage = "Unknown error";
  let errorStatus = 500;

  if (isRouteErrorResponse(error)) {
    errorMessage = error.data?.message || error.statusText;
    errorStatus = error.status;
  } else if (error instanceof Error) {
    errorMessage = error.message;
  }

  return (
    <html lang="en">
      <head>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width,initial-scale=1" />
        <title>Error - ShowPics</title>
        <Meta />
        <Links />
      </head>
      <body>
        <div
          style={{
            padding: "40px",
            fontFamily: "system-ui, sans-serif",
            maxWidth: "600px",
            margin: "0 auto",
          }}
        >
          <h1 style={{ color: "#dc2626" }}>
            {errorStatus === 404 ? "Page Not Found" : "Something went wrong"}
          </h1>
          <p style={{ color: "#6b7280", marginTop: "16px" }}>{errorMessage}</p>
          <button
            onClick={() => (window.location.href = "/app")}
            style={{
              marginTop: "24px",
              padding: "10px 20px",
              backgroundColor: "#2563eb",
              color: "white",
              border: "none",
              borderRadius: "6px",
              cursor: "pointer",
              fontSize: "16px",
            }}
          >
            Go to Dashboard
          </button>
        </div>
        <Scripts />
      </body>
    </html>
  );
};

export default withSentry(App);
